export default __webpack_public_path__ + "static/media/blur.184bccf3.svg";